const QUOTES = [
  {
    text:
      "I used to pick properties on gut feel. Axiom showed me the numbers behind every deal. Now I actually understand where my money goes.",
    name: "Marcus C.",
    title: "First-time investor · Sydney",
    metric: "+42% in 18 months",
  },
  {
    text:
      "They told me NOT to buy three properties I was excited about. Six months later, all three lost money. That advice paid for itself many times over.",
    name: "Rachel O.",
    title: "Small landlord · Brisbane",
    metric: "3 bad deals avoided",
  },
  {
    text:
      "That's exactly why we're here. Everything is explained in simple English, with no jargon or confusing terms. Ask anything — every question is welcome.",
    name: "Liam A.",
    title: "Property owner · Melbourne",
    metric: "5 years with Axiom",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32 lg:py-40 bg-[#0A0A0A]"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-16">
        <div className="mb-16">
          <div className="data-label mb-6">/ What People Say</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight max-w-3xl">
            Real people. <span className="italic text-white/60">Real results.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10">
          {QUOTES.map((q, i) => (
            <figure
              key={q.name}
              data-testid={`testimonial-${i}`}
              className="bg-[#0F0F0F] p-10 lg:p-12 flex flex-col justify-between min-h-[360px]"
            >
              <blockquote className="font-display text-2xl lg:text-3xl leading-snug text-white/90">
                <span className="text-gold mr-1">“</span>
                {q.text}
                <span className="text-gold ml-1">”</span>
              </blockquote>
              <div className="mt-10 pt-6 border-t border-white/10 flex items-end justify-between gap-4">
                <figcaption>
                  <div className="text-white font-medium text-[15px]">{q.name}</div>
                  <div className="text-white/55 text-xs tracking-[0.15em] uppercase mt-1">
                    {q.title}
                  </div>
                </figcaption>
                <span className="font-mono text-[10px] tracking-[0.25em] text-gold uppercase">
                  {q.metric}
                </span>
              </div>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
